export default "__VITE_ASSET__CRSkcZFy__"